import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { selectMill, isPdf } from "../actions/millActions";
import { toggleTour, setCarousel } from "../actions/settingActions";

import { Link, withRouter } from "react-router-dom";
import DocumentTitle from "react-document-title";

import Info from "./InfoPopup.js";

import { ReactComponent as ArrowBack } from "../icons/arrow_circle_down.svg";

import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Dialog from "@material-ui/core/Dialog";
import Toolbar from "@material-ui/core/Toolbar";
import Grid from "@material-ui/core/Grid";
import Tooltip from "@material-ui/core/Tooltip";

const styles = (theme) => ({
  appBar: {
    height: "66px",
    position: "relative",
    backgroundColor: "white",
    color: theme.palette.primary.main,
    borderBottom: `2px solid ${theme.palette.primary.main}`,
    padding: "0px 15px",
    width: "100%",
  },
  tooltip: {
    backgroundColor: "white",
    color: "#00568E",
    fontSize: "9pt",
    border: "1px solid #00568E",
  },
});

class Media extends Component {
  componentDidMount() {
    this.props.isPdf(true);
    if (this.props.tourOpen) {
      this.props.toggleTour();
    }
  }

  render() {
    const path = `${process.env.REACT_APP_DOCUMENT_URL}/medien/`;
    return (
      <Dialog
        fullScreen
        open={true}
        style={{ zIndex: 1302 }}
        onClose={() => {
          this.props.setCarousel("mills");
          this.props.history.push("/muehlenkataster");
        }}
      >
        <DocumentTitle title="Medien | Mühlen im Kreis Herford">
          <div>
            <AppBar
              position="static"
              className={this.props.classes.appBar}
              id="topanchor"
            >
              <Toolbar style={{ padding: 0, height: "inherit" }} id="topAnchor">
                <Tooltip
                  title="zurück"
                  classes={{
                    tooltip: this.props.classes.tooltip,
                  }}
                >
                  <Link
                    to="/muehlenkataster"
                    style={{
                      textDecoration: "none",
                      color: "#00568E",
                      padding: 0,
                    }}
                    onClick={() => {
                      this.props.setCarousel("mills");
                      this.props.isPdf(false);
                    }}
                  >
                    <ArrowBack style={{ transform: "rotate(90deg)" }} />
                  </Link>
                </Tooltip>

                <div
                  style={{
                    fontWeight: "bold",
                    flexGrow: 1,
                    marginLeft: "calc(10px - 40px + 37.3667px)",
                    color: "#00568E",
                  }}
                >
                  Mühlen im Kreis Herford
                </div>
                <Info color={"#00568E"} information={true} />
              </Toolbar>
            </AppBar>
            <div
              style={{
                margin: "20px",
                fontWeight: "700",
                fontSize: "16px",
                color: "#00568E",
              }}
            >
              Video
            </div>
            <Grid
              container
              spacing={0}
              style={{
                justifyContent: "center",
              }}
            >
              <Grid xs={12} sm={6}>
                <div style={{ margin: "20px" }}>
                  <div
                    style={{
                      fontWeight: "600",
                    }}
                  >
                    Der Mühlen-Bauhof des Mühlenvereins Minden-Lübbecke
                  </div>
                  <div
                    style={{
                      fontStyle: "italic",
                    }}
                  >
                    Film: Michael Trappmann in Kooperation mit „Handwerk trifft
                    Kultur“, einem Gemeinschaftsprojekt der Kreise Herford und
                    Minden-Lübbecke,{" "}
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className={"appLink"}
                      href="www.handwerk-trifft-kultur.de"
                    >
                      www.handwerk-trifft-kultur.de
                    </a>
                  </div>
                  <video controls width="100%" style={{ marginTop: "10px" }}>
                    <source
                      src={`${path}Der Mühlenverein_FHD.MP4`}
                      type="video/mp4"
                    />
                    Ihr Browser unterstützt keine eingebetteten Medien.
                  </video>
                </div>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={0}
              style={{
                justifyContent: "center",
              }}
            >
              <Grid xs={12} sm={6}>
                <div style={{ margin: "20px" }}>
                  <div
                    style={{
                      fontWeight: "600",
                    }}
                  >
                    Rüttelschuh in Aktion an der Rürupsmühle in Löhne
                  </div>
                  <div
                    style={{
                      fontStyle: "italic",
                    }}
                  >
                    Film: Christoph Mörstedt
                  </div>
                  <video controls width="100%" style={{ marginTop: "10px" }}>
                    <source
                      src={`${path}MVI_0807_Rüttelschuh Wassermühle_CM.MP4`}
                      type="video/mp4"
                    />
                    Ihr Browser unterstützt keine eingebetteten Medien.
                  </video>
                </div>
              </Grid>
              <Grid xs={12} sm={6}>
                <div style={{ margin: "20px" }}>
                  <div
                    style={{
                      fontWeight: "600",
                    }}
                  >
                    Wasserrad der Rürupsmühle in Löhne
                  </div>
                  <div
                    style={{
                      fontStyle: "italic",
                    }}
                  >
                    Film: Christoph Mörstedt
                  </div>
                  <video controls width="100%" style={{ marginTop: "10px" }}>
                    <source
                      src={`${path}MVI_0808_wasserrad mit wasser_CM.MP4`}
                      type="video/mp4"
                    />
                    Ihr Browser unterstützt keine eingebetteten Medien.
                  </video>
                </div>
              </Grid>
            </Grid>
            <div
              style={{
                width: "calc(100% - 1.25rem - 1.25rem)",
                borderTop: "1px solid #00568E",
                padding: "20px 0",
                margin: "0 1.25rem",
                marginTop: "30px",
                paddingBottom: "10px",
              }}
            ></div>
            <div
              style={{
                margin: "20px",
                marginBottom: "10px",
                marginTop: 0,
                fontWeight: "700",
                fontSize: "16px",
                color: "#00568E",
              }}
            >
              Audio
            </div>
            <div
              style={{
                fontStyle: "italic",
                margin: "0 20px",
                marginBottom: "10px",
              }}
            >
              Aufnahmen: Michael Trappmann in Kooperation mit „Handwerk trifft
              Kultur“, einem Gemeinschaftsprojekt der Kreise Herford und
              Minden-Lübbecke,{" "}
              <a
                target="_blank"
                rel="noopener noreferrer"
                className={"appLink"}
                href="www.handwerk-trifft-kultur.de"
              >
                www.handwerk-trifft-kultur.de
              </a>
            </div>
            <Grid
              container
              spacing={0}
              style={{
                justifyContent: "center",
                marginBottom: "30px",
              }}
            >
              <Grid xs={12} sm={6} lg={4}>
                <div style={{ margin: "20px" }}>
                  <div
                    style={{
                      fontWeight: "600",
                    }}
                  >
                    Geräusch des Kornmahlens von Hand
                  </div>
                  <audio
                    controls
                    src={`${path}Mühlenverein_Korn_Reiben_Mahlen_Von_Hand_Stein_Variabel.wav`}
                    style={{ width: "100%", marginTop: "10px" }}
                  >
                    Ihr Browser unterstützt keine eingebetteten Medien.
                  </audio>
                </div>
              </Grid>
              <Grid xs={12} sm={6} lg={4}>
                <div style={{ margin: "20px" }}>
                  <div
                    style={{
                      fontWeight: "600",
                    }}
                  >
                    Geräusch einer elektrischen Kreissäge
                  </div>
                  <audio
                    controls
                    src={`${path}Mühlenverein_Kreissäge_Elektrisch_Holz_Werkstatt_Werkzeug.wav`}
                    style={{ width: "100%", marginTop: "10px" }}
                  >
                    Ihr Browser unterstützt keine eingebetteten Medien.
                  </audio>
                </div>
              </Grid>
              <Grid xs={12} sm={6} lg={4}>
                <div style={{ margin: "20px" }}>
                  <div
                    style={{
                      fontWeight: "600",
                    }}
                  >
                    Geräusch einer trocken drehenden Mühle
                  </div>
                  <audio
                    controls
                    src={`${path}Mühlenverein_Modellmühle_Trocken_Drehen_Holz_Mechanik_Klappern_Langsam_Mono.wav`}
                    style={{ width: "100%", marginTop: "10px" }}
                  >
                    Ihr Browser unterstützt keine eingebetteten Medien.
                  </audio>
                </div>
              </Grid>
              <Grid xs={12} sm={6} lg={4}>
                <div style={{ margin: "20px" }}>
                  <div
                    style={{
                      fontWeight: "600",
                    }}
                  >
                    Geräusch Wasserplätschern
                  </div>
                  <audio
                    controls
                    src={`${path}Mühlenverein_Modellmühle_Wasser_Plätschern_Kontinuierlich_Stereo.wav`}
                    style={{ width: "100%", marginTop: "10px" }}
                  >
                    Ihr Browser unterstützt keine eingebetteten Medien.
                  </audio>
                </div>
              </Grid>
              <Grid xs={12} sm={6} lg={4}>
                <div style={{ margin: "20px" }}>
                  <div
                    style={{
                      fontWeight: "600",
                    }}
                  >
                    Geräusch des Rüttelschuhs beim Mahlen
                  </div>
                  <audio
                    controls
                    src={`${path}Mühlenverein_Rüttelwerk_Korn_Mahlen_Holz_Schlagen_Rhythmisch_Mechanik_Stereo.wav`}
                    style={{ width: "100%", marginTop: "10px" }}
                  >
                    Ihr Browser unterstützt keine eingebetteten Medien.
                  </audio>
                </div>
              </Grid>
            </Grid>
          </div>
        </DocumentTitle>
      </Dialog>
    );
  }
}

Media.propTypes = {
  selected: PropTypes.object.isRequired,
  progress: PropTypes.bool.isRequired,
  toggleTour: PropTypes.func.isRequired,
  tourOpen: PropTypes.bool.isRequired,
  selectMill: PropTypes.func.isRequired,
  mills: PropTypes.object.isRequired,
  setCarousel: PropTypes.func.isRequired,
  isPdf: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  progress: state.mill.progress,
  selected: state.mill.selected,
  tourOpen: state.settings.tour,
  mills: state.mill.mills,
});

export default connect(mapStateToProps, {
  toggleTour,
  selectMill,
  setCarousel,
  isPdf,
})(withStyles(styles, { withTheme: true })(withRouter(Media)));
